export enum TypeEnum {
    INSTITUTION = "institution",
    REGULATION_STATUS = "regulation_status"
}